'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('home', {
      url: '/home',
      template: '<home></home>',
        authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/home/home.routes.js